var React = require('react');

function MinusSign (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.968 0C3.126 0 0 3.126 0 6.968s3.126 6.968 6.968 6.968 6.968-3.126 6.968-6.968S10.809 0 6.968 0zm3.349 7.503H3.618a.536.536 0 110-1.072h6.699a.536.536 0 010 1.072zm0 0"}));
}

MinusSign.defaultProps = {"width":"13.935","height":"13.935","viewBox":"0 0 13.935 13.935"};

module.exports = MinusSign;

MinusSign.default = MinusSign;
